import img1 from '@/public/images/landing/useCases/img1.webp';
import img2 from '@/public/images/landing/useCases/img2.webp';
import img3 from '@/public/images/landing/useCases/img3.webp';
import img4 from '@/public/images/landing/useCases/img4.webp';

export const useCasesData = [
	{
		id: 'products',
		title: 'products_title',
		text: 'products_text',
		image: img1,
		link: '/',
	},
	{
		id: 'engagement',
		title: 'engagement_title',
		text: 'engagement_text',
		image: img2,
		link: '/',
	},
	{
		id: 'enhance',
		title: 'enhance_title',
		text: 'enhance_text',
		image: img3,
		link: '/',
	},
	{
		id: 'creativity',
		title: 'creativity_title',
		text: 'creativity_text',
		image: img4,
		link: '/',
	},
];
